const doc = [({"ja":({"adminComponentAdminTop":({"firstHotelRegistrationMessage":"施設の登録をしてください。{{num}}施設登録することができます。"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;